import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-tester",
  "use": "icon-leo-tester-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-tester\">\r\n<g transform=\"translate(-176.128 -90.112) scale(1.344000)\">\r\n<path d=\"M320 128h384v128l-64 64v448H384V320l-64-64V128zm96 64v48h192v-48H416zm32 160h128v384H448V352z\" />\r\n  <path d=\"M480 448h64v64h-64v-64zm0 128h64v64h-64v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-tester.svg
// module id = piOz
// module chunks = 446